module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "get-code",
    style: ({
      cursor: (_vm.code === 'Send Code' || _vm.code === '获取验证码' ? 'pointer' : 'not-allowed')
    }),
    on: {
      "click": _vm.sendCode
    }
  }, [_vm._v("\n  " + _vm._s(_vm.code) + "\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-729f3a06"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/new-login-2018/components/GetCode.vue
// module id = 734
// module chunks = 1